import { FOUNDATION_ROUTES } from '@philips-emr/hpms-provider-accreditation-commons';
import Controller, { OnClick } from '@philips-emr/tws-core/lib/client';

import BaseController from '../BaseController';

@Controller({ fragment: 'register-user-success' })
export default class NewUserSuccessController extends BaseController{

  @OnClick('button-confirmation')
  onClick(): void {
    this.historyService.push(FOUNDATION_ROUTES.LOGIN);
  }
}
